<div class="county-selector-wrapper">
  <label [for]="'county-select-' + stateCode" class="county-selector-label">
    {{ label }}
    @if (required) {
      <span class="required-indicator" aria-label="required">*</span>
    }
  </label>
  
  <mat-form-field appearance="outline" class="county-selector-field">
    <mat-select
      [id]="'county-select-' + stateCode"
      [value]="value"
      [placeholder]="placeholder"
      [disabled]="isDisabled() || readonly"
      [attr.data-pw]="dataPw || null"
      [attr.data-qa]="dataQa || null"
      [attr.data-test]="dataTest || null"
      [attr.data-testid]="dataTestid || null"
      [attr.data-e2e]="dataE2e || null"
      [attr.aria-label]="label"
      [attr.aria-required]="required"
      (selectionChange)="onSelectionChange($event.value)"
      (blur)="onBlur()">
      
      <!-- Filter input inside select panel -->
      <mat-select-trigger>
        {{ value || placeholder }}
      </mat-select-trigger>
      
      <div class="county-filter-container">
        <mat-form-field appearance="outline" class="county-filter-field">
          <input
            matInput
            [formControl]="filterControl"
            placeholder="Search counties..."
            class="county-filter-input"
            (click)="$event.stopPropagation()"
            autocomplete="off" />
          @if (filterControl.value) {
            <button
              mat-icon-button
              matSuffix
              (click)="clearFilter(); $event.stopPropagation()"
              type="button"
              class="clear-filter-btn">
              ✕
            </button>
          }
        </mat-form-field>
      </div>
      
      <!-- County options -->
      @if (isLoading()) {
        <mat-option disabled>Loading counties...</mat-option>
      } @else if (filteredCounties().length === 0 && counties().length === 0) {
        <mat-option disabled>No counties available</mat-option>
      } @else if (filteredCounties().length === 0) {
        <mat-option disabled>No matching counties</mat-option>
      } @else {
        @for (county of filteredCounties(); track county.id) {
          <mat-option [value]="county.name">
            {{ county.name }}
          </mat-option>
        }
      }
    </mat-select>
  </mat-form-field>
</div>
